// Hooks
import useTranslate from "hooks/useTranslate";

// Icons
import SuccessInvert from "assets/icons/glory/success_invert.svg?react";
import Success from "assets/icons/glory/success.svg?react";
import CopyIcon from "assets/icons/glory/copy.svg?react";

import "./styles.sass";

type SuccessNoteProps = {
  type: "account" | "transaction";
};

const SuccessNote = (props: SuccessNoteProps) => {
  const { type } = props;
  const t = useTranslate();
  return (
    <>
      {type === "account" && (
        <div className="SuccessNote">
          {t("profile.account.data.success")}
          <SuccessInvert />
        </div>
      )}
      {type === "transaction" && (
        <div className="SuccessNoteTransaction">
          {t("profile.balance.deposit.copied")}
          <CopyIcon className="SuccessNoteTransaction__copy" />
          <Success className="SuccessNoteTransaction__success" />
        </div>
      )}
    </>
  );
};

export default SuccessNote;
